/*
 *
 * LanguageProvider constants
 *
 */

export const CHANGE_LOCALE = 'App/LanguageToggle/CHANGE_LOCALE';
